import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import {
  getReportingEmployees,
} from "../../../core/data/redux/reportingEmployeesSlice";
import { useDispatch, useSelector } from "react-redux";
import Toasts from "../../../core/common/toast";
import { Avatar } from "antd";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import TeamOffices from "./teamOffices";
interface ReportingEmployeesProps {}

const ReportingEmployees = (props: ReportingEmployeesProps) => {
  const navigate = useNavigate();

  const reportingEmployeesState = useSelector(
    (state: any) => state.reportingEmployeesState
  );

  const [officeEmployee, setOfficeEmployee] = useState<any>(null);
  const dispatch = useDispatch();

  const [dataList, setDataList] = React.useState<any[]>([]);
  const routes = all_routes;
  const [query, setQuery] = useState<any>("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  const fetchRecords = (pagination: any, query: string) => {
    dispatch(
      getReportingEmployees({
        page: pagination.current,
        limit: pagination.pageSize,
        query: query,
      })
    );
  };

  const handleSearch = (query: string) => {
    fetchRecords(pagination, query);
  };

  React.useEffect(() => {
    fetchRecords(pagination, query);
  }, []);

  React.useEffect(() => {
    if (
      reportingEmployeesState.loading === "fulfilled" &&
      reportingEmployeesState.action === "assign"
    ) {
      fetchRecords(pagination, query);
    } else if (
      reportingEmployeesState.loading === "fulfilled" &&
      reportingEmployeesState.action === "list"
    ) {
      const result = reportingEmployeesState?.data?.data || null;
      if (result.data && result.data.length > 0) {
        const employees = result?.data || [];
        setDataList(employees);
        setPagination({
          ...pagination,
          total: result.total || employees.length,
          current: result.page || 1,
          pageSize: result.limit || 10,
        });
      } else {
        setDataList([]);
      }
    }
  }, [reportingEmployeesState.loading]);

  const randomAvatar = (firstName: string) => {
    const colors = [
      "#f56a00",
      "#7265e6",
      "#ffbf00",
      "#00a2ae",
      "#87d068",
      "#d46b08",
    ];
    const index = Math.floor(Math.random() * colors.length);
    const initial = firstName?.charAt(0)?.toUpperCase() || "?";
    return {
      bg: colors[index],
      initial,
    };
  };


 
  
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <div>
          {pagination.current
            ? index +
              pagination.current * pagination.pageSize -
              pagination.pageSize +
              1
            : index + 1}
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "firstname",
      render: (text: string, record: any) => {
        const first = record?.firstname?.trim() || "";
        const last =
          record?.lsastname?.trim() || record?.lastname?.trim() || "";

        if (!first && !last) {
          return <div style={{ height: "40px" }}></div>;
        }

        const avatarInfo = randomAvatar(first);

        return (
          <div className="d-flex align-items-center">
            {record?.image ?
              <Avatar
                src={`data:image/jpeg;base64,${record.image}`}
                className="me-2"
                style={{
                  backgroundColor: avatarInfo.bg,
                  verticalAlign: "middle",
                  width: '50px',
                  height: '50px'
                }}
              ></Avatar>
              :
              <Avatar
                className="me-2"
                style={{
                  backgroundColor: avatarInfo.bg,
                  verticalAlign: "middle",
                  width: '50px',
                  height: '50px'
                }}
              >
                {avatarInfo.initial}
              </Avatar>
            }
            <div>{`${first} ${last}`.trim()}</div>
          </div>
        );
      },
    },
    {
      title: "Emp ID",
      dataIndex: "empId",
      render: (empId: string) => parseInt(empId, 10),
    },
    
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Wing",
      dataIndex: "sap_department_designation_wings",
      render: (sap_department_designation_wings: any) =>
        sap_department_designation_wings?.wing_name ? `${sap_department_designation_wings?.wing_name}` : "",
    },
    {
      title: "Department",
      dataIndex: "sap_department_designation_wings",
      render: (sap_department_designation_wings: any) =>
        sap_department_designation_wings?.department_name ? `${sap_department_designation_wings?.department_name}` : "",
    },
    {
      title: "Designation",
      dataIndex: "sap_department_designation_wings",
      render: (sap_department_designation_wings: any) =>
        sap_department_designation_wings?.designation_name ? `${sap_department_designation_wings?.designation_name}` : "",
    },
    // {
    //   title: "Joining Date",
    //   dataIndex: "employee",
    //   render: (employee: any) =>
    //     employee?.created_at
    //       ? dayjs(employee?.created_at).format("DD MMM YYYY")
    //       : "-",
    // },
    {
      title: "Actions",
      dataIndex: "actions",
      width: 120,
      render: (_: any, record: any) => (
        <div className="d-inline-flex" style={{ gap: 8 }}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Attendance</Tooltip>}
          >
            <button
              type="button"
              className="icon-hover-btn"
              data-bs-placement="top"
              onClick={() =>
                navigate(routes.reportingEmployeeAttendance, {
                  state: { empId: record.empId },
                })
              }
            >
              <i className="ti ti-calendar-stats" />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Shift</Tooltip>}
          >
            <button
              type="button"
              className="icon-hover-btn"
              data-bs-placement="top"
              onClick={() =>
                navigate(routes.reportingEmployeeShift, {
                  state: { employee: record },
                })
              }
            >
              <i className="ti ti-calendar-stats" />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Leave</Tooltip>}
          >
            <button
              type="button"
              className="icon-hover-btn"
              data-bs-placement="top"
              onClick={() =>
                navigate(routes.LeaveManagement.list, {
                  state: { empId: record.empId,  },
                })
              }
            >
              <i className="ti ti-notebook" />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Assign Office</Tooltip>}
          >
            <button
              type="button"
              className="icon-hover-btn"
              data-bs-toggle="modal"
              data-bs-target="#assign_office_modal"
              data-bs-placement="top"
              onClick={() => setOfficeEmployee(record)}
            >
              <i className="ti ti-building" />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Work Schedule</Tooltip>}
          >
            <button
              type="button"
              className="icon-hover-btn"
              // data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={() =>
                navigate(routes.employeeWorkSchedule, {
                  state: { employee: record },
                })
              }
            >
              <i className="ti ti-clock-hour-8" />
            </button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  const employeeStats = [
    {
      title: "Total Employee",
      count: dataList.length,
      color: "#1f2937", // dark gray
      icon: "ti ti-users",
      badgeBg: "#f3e8ff",
      badgeColor: "#a855f7",
    },
    {
      title: "Active",
      count: 1007,
      color: "#22c55e", // green
      icon: "ti ti-user-check",
      badgeBg: "#fef2f2",
      badgeColor: "#ef4444",
    },
    {
      title: "InActive",
      count: 1007,
      color: "#ef4444", // red
      icon: "ti ti-user-off",
      badgeBg: "#f3f4f6",
      badgeColor: "#6b7280",
    },
    {
      title: "New Joiners",
      count: 67,
      color: "#3b82f6", // blue
      icon: "ti ti-user-plus",
      badgeBg: "#e0f2fe",
      badgeColor: "#2563eb",
    },
  ];

  const handlePagination = (pagination: any) => {
    setPagination({
      current: pagination.page,
      pageSize: pagination.pageSize,
      total: pagination.total || 10,
    });
    fetchRecords(pagination, query);
  };

  return (
    <div>
      <>
        <Toasts
          show={reportingEmployeesState.loading === "rejected"}
          message={reportingEmployeesState.error}
          title={"Failed"}
          type={"danger"}
        />
        <Toasts
          show={
            reportingEmployeesState.loading === "fulfilled" &&
            reportingEmployeesState.action != "list"
          }
          message={reportingEmployeesState?.data?.message}
          title={"Success"}
          type={"success"}
        />
        <div className="page-wrapper">
          <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Team List</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Employees</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Team List
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

            {/* Employee Statistics Dashboard */}
            {/* <div className="row">
              {employeeStats.map((stat, index) => (
                <div className="col-md-3" key={index}>
                  <div className="card shadow-sm border-0">
                    <div className="card-body d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: 50,
                            height: 50,
                            backgroundColor: stat.color,
                            color: "#fff",
                          }}
                        >
                          <i className={stat.icon} style={{ fontSize: 22 }} />
                        </div>
                        <div>
                          <div className="fw-semibold text-muted small mb-1">
                            {stat.title}
                          </div>
                          <h2 className="mb-0">{stat.count}</h2>
                        </div>
                      </div>
                      <span
                        className="badge"
                        style={{
                          backgroundColor: stat.badgeBg,
                          color: stat.badgeColor,
                          fontSize: "0.75rem",
                          padding: "6px 10px",
                        }}
                      >
                        ⟳ +19.01%
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div> */}

            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                <h4 className="mb-4 mt-3">Team List</h4>
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  style={{
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "0.5rem",
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                >
                  <i className="ti ti-calendar-stats" /> Daily Attendance
                </button>
              </div>
              <div className="card-body p-0 py-3">
                <Table
                  columns={columns}
                  dataSource={dataList}
                  Selection={false}
                  paginationConfig={pagination}
                  handlePagination={handlePagination}
                  loading={reportingEmployeesState.loading === "pending"}
                  handleSearch={handleSearch}
                />
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="datatable-paginate mt-4" />
              </div>
            </div>
          </div>
        </div>
      </>
      {/* Assign Office Modal */}
      <div
        className="modal fade"
        id="assign_office_modal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="assignOfficeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Assign office</h4>
                <span>
                  Employee ID : {parseInt(officeEmployee?.empId || "0", 10)}
                </span>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <TeamOffices employee={officeEmployee} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportingEmployees;
